// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3343":"1f3ce52d","4570":"de230fd2","4872":"1f3ce52d","5658":"57f17635","6105":"1c286af9","9996":"1f3ce52d"}[chunkId] + ".chunk.css";
};